import $ from "jquery";

$(function() {
    $(".bl-faqs").each(function() {
        initBlock($(this));
    });
});

function initBlock($bl) {
    const animspeed = 200;

    $bl.on("click", ".summary", function () {
        const $accitem = $(this).closest(".accitem");
        const $openItems = $bl.find(".accitem.expanded").not($accitem);
        
        // close all other open items
        $openItems.each(function () {
            closeItem($(this), animspeed);
        });

        // toggle clicked item
        if ($accitem.hasClass("expanded")) {
            closeItem($accitem, animspeed);
        } else {
            openItem($accitem, animspeed);
        }
    });
}

function openItem($accitem, animspeed) {
    const $details = $accitem.find(".details");

    $accitem.addClass("expanded");
    $details.slideDown(animspeed);
}

function closeItem($accitem, animspeed) {
    const $details = $accitem.find(".details");

    $accitem.removeClass("expanded");
    $details.slideUp(animspeed);
}